<template>
  <div class="page-container">
    <div class="page-decor">
      <div class="decor-orb orb-1"></div>
      <div class="decor-orb orb-2"></div>
      <div class="decor-line line-1"></div>
      <div class="decor-line line-2"></div>
    </div>

    <section class="page-hero">
      <div class="page-hero-content">
        <div class="page-badge">{{ localize('ABOUT_BADGE') }}</div>
        <h1 class="page-title">{{ localize('ABOUT_TITLE') }}</h1>
        <p class="page-subtitle">{{ localize('ABOUT_SUBTITLE') }}</p>
      </div>
    </section>

    <section class="page-section">
      <div class="section-inner">
        <div class="content-card">
          <h2 class="content-heading">{{ localize('ABOUT_FOUNDED_TITLE') }}</h2>
          <p class="content-text">{{ localize('ABOUT_FOUNDED_DESC') }}</p>
        </div>

        <div class="content-card">
          <h2 class="content-heading">{{ localize('ABOUT_CHALLENGE_TITLE') }}</h2>
          <p class="content-text">{{ localize('ABOUT_CHALLENGE_DESC') }}</p>
        </div>

        <div class="content-card">
          <h2 class="content-heading">{{ localize('ABOUT_SOLUTION_TITLE') }}</h2>
          <p class="content-text">{{ localize('ABOUT_SOLUTION_DESC') }}</p>
        </div>

        <div class="content-card">
          <h2 class="content-heading">{{ localize('ABOUT_MISSION_TITLE') }}</h2>
          <div class="mission-list">
            <div class="mission-item" v-for="n in 3" :key="n">
              <div class="mission-bullet"></div>
              <span>{{ localize('ABOUT_MISSION_' + n) }}</span>
            </div>
          </div>
        </div>

        <div class="content-card">
          <h2 class="content-heading">{{ localize('ABOUT_HQ_TITLE') }}</h2>
          <p class="content-text">{{ localize('ABOUT_HQ_DESC') }}</p>
        </div>

        <div class="contact-block">
          <div class="contact-label">Compdeep G.K.</div>
          <div class="contact-detail">Tokyo, Japan</div>
          <div class="contact-detail">contact@compdeep.com</div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

import {translationStore} from "@/stores/translation";

export default {
    "name": "About",
    setup () {

        const translation = translationStore();

        return {
            "localize": translation.localize
        };

    }
};

</script>
<style scoped>
/* ---- Design System Tokens ---- */
.page-container {
  --purple: #7c3aed;
  --magenta: #ec4899;
  --cyan: #06b6d4;
  --indigo: #6366f1;
  --text-primary: #0f0d15;
  --text-secondary: #4a4458;
  --text-muted: #8b83a0;
  --bg-primary: #fff;
  --bg-card: #f8f7fb;
  --border-subtle: #e9e5f0;
  --accent-purple: #7c3aed;
  --font-heading: 'Space Grotesk', sans-serif;
  --font-body: 'Space Grotesk', sans-serif;
  --font-mono: 'JetBrains Mono', monospace;
  --gradient-text: linear-gradient(135deg, var(--purple), var(--indigo), var(--cyan));
  --gradient-cta: linear-gradient(135deg, var(--magenta), var(--cyan));
  --gradient-divider: linear-gradient(90deg, var(--magenta), var(--cyan));

  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: var(--bg-primary);
  font-family: var(--font-body);
  color: var(--text-primary);
}

/* ---- Decorative Elements ---- */
.page-decor {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}
.decor-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.15;
}
.orb-1 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(124, 58, 237, 0.25), rgba(99, 102, 241, 0.1) 50%, transparent 70%);
  top: -150px;
  right: -100px;
  animation: drift-1 25s ease-in-out infinite;
}
.orb-2 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(6, 182, 212, 0.2), rgba(99, 102, 241, 0.08) 50%, transparent 70%);
  bottom: 10%;
  left: -100px;
  animation: drift-2 30s ease-in-out infinite;
}
.decor-line {
  position: absolute;
  background: linear-gradient(180deg, transparent, var(--border-subtle), transparent);
  opacity: 0.35;
}
.line-1 {
  width: 1px;
  height: 60%;
  top: 10%;
  left: 15%;
}
.line-2 {
  width: 1px;
  height: 50%;
  top: 20%;
  right: 20%;
}
@keyframes drift-1 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-40px, 60px); }
}
@keyframes drift-2 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(50px, -40px); }
}

/* ---- Hero ---- */
.page-hero {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  padding: 100px 20px 60px;
  text-align: center;
}
.page-hero-content {
  max-width: 700px;
}
.page-badge {
  display: inline-block;
  padding: 8px 20px;
  margin-bottom: 28px;
  font-family: var(--font-mono);
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--purple);
  border: 1px solid rgba(124, 58, 237, 0.1);
  border-radius: 4px;
  background: rgba(124, 58, 237, 0.06);
}
.page-title {
  font-family: var(--font-heading);
  font-size: 2.8em;
  font-weight: 800;
  line-height: 1.15;
  margin: 0 0 24px;
  letter-spacing: -1px;
  background: var(--gradient-text);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.page-subtitle {
  font-family: var(--font-body);
  font-size: 1.05em;
  line-height: 1.8;
  color: var(--text-secondary);
  margin: 0;
}

/* ---- Gradient Divider between hero and content ---- */
.page-hero::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: min(80%, 600px);
  height: 3px;
  background: linear-gradient(90deg, #ec4899, #06b6d4);
  border-radius: 0;
}

/* ---- Content ---- */
.page-section {
  position: relative;
  z-index: 1;
  padding: 0 20px 100px;
}
.section-inner {
  max-width: 800px;
  margin: 0 auto;
}
.content-card {
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-left: 3px solid var(--accent-purple);
  border-radius: 0px;
  padding: 36px 32px;
  margin-bottom: 24px;
  box-shadow: none;
  transition: border-color 0.3s ease;
}
.content-card:hover {
  box-shadow: none;
  transform: none;
  border-left-color: var(--magenta);
}
.content-heading {
  font-family: var(--font-heading);
  font-size: 1.25em;
  font-weight: 800;
  margin: 0 0 16px;
  letter-spacing: -0.3px;
  background: var(--gradient-text);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.content-text {
  font-family: var(--font-body);
  font-size: 0.95em;
  color: var(--text-secondary);
  line-height: 1.85;
  margin: 0;
}
.mission-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.mission-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  font-family: var(--font-body);
  font-size: 0.95em;
  color: var(--text-secondary);
  line-height: 1.7;
}
.mission-bullet {
  width: 8px;
  height: 8px;
  border-radius: 0px;
  background: var(--gradient-cta);
  flex-shrink: 0;
  margin-top: 9px;
}
.contact-block {
  text-align: center;
  padding: 40px 32px;
  margin-top: 48px;
  border-top: 3px solid transparent;
  border-image: linear-gradient(90deg, #ec4899, #06b6d4) 1;
}
.contact-label {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 14px;
  letter-spacing: 3px;
  text-transform: uppercase;
}
.contact-detail {
  font-family: var(--font-body);
  font-size: 0.9em;
  color: var(--text-muted);
  margin-bottom: 4px;
}

/* ---- Dark Mode ---- */
@media (prefers-color-scheme: dark) {
  .page-container {
    --text-primary: #f0edf5;
    --text-secondary: #b0a8c0;
    --text-muted: #706882;
    --bg-primary: #0f0d15;
    --bg-card: #1a1724;
    --border-subtle: #2a2537;
    --accent-purple: #7c3aed;
  }
}

@media (max-width: 750px) {
  .page-hero { padding: 80px 20px 40px; }
  .page-title { font-size: 1.9em; }
  .content-card { padding: 24px 20px; }
  .contact-block { padding: 32px 20px; }
}
</style>
